export const sortNumbers = (arr: Array<number>) => {
  return [...arr].sort((a, b) => a - b);
};

export const sortNumericStrings = (arr: Array<string>) => {
  return [...arr].sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
}

const firstPartitionIndex = (sortedArr: Array<number>) => {
  let index = 0;
  const diff = sortedArr[1] - sortedArr[0];

  while (diff === sortedArr[index + 1] - sortedArr[index]) {
    index++;
  }

  return index;
}

export const partitionByDiff = (sortedArray: Array<number>): Array<{
  diff: number,
  items: Array<number>
}> => {
  const partitions = [];
  let values = [...sortedArray];

  while (values.length !== 0) {
    const diff = values[1] - values[0];
    let partitionIndex = firstPartitionIndex(values);

    partitions.push({
      diff: diff,
      items: values.slice(0, partitionIndex + 1)
    });

    values = values.slice(partitionIndex + 1);
    partitionIndex = 0;
  }

  return partitions;
}
